export const php = {
  configuration: {
    code: "PHP Code",
    warning: "Warnung"
  }
};
